import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";
import { report } from "../../gateways/unilabReport";
// eslint-disable-next-line no-unused-vars
import store from "../../store";

export default {
  supportDesign(modality) {
    if (modality <= 7) {
      // COILS
      return false;
    }
    if (modality <= 11) {
      // PHE
      return true;
    }
    return false;
  },
  createProject(modality, performDesign = false, performSelection = false) {
    return new Promise((resolve, reject) => {
      // if (modality == 1 || modality == 2 || modality == 3 || modality == 4)
      // {
      api
        .get(`project/new/${modality}/${performDesign}/${performSelection}/false`)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            Notification.warning({
              title: "Error",
              message: response.response !== undefined ? response.response.data : "No Response"
            });
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          Notification.warning({
            title: "Error",
            message: error
          });
          reject(error);
        });
      /* }
      else
      {
        Notification.warning({
            title: 'Warning',
            message: 'Modality not supported yet'
        });
      } */
    });
  },
  saveProject(project) {
    let prj = {};
    for (const el in project) {
      prj = project[el];
    }
    return new Promise((resolve, reject) => {
      api
        .post("project/save", prj)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            Notification.warning({
              title: "Error",
              message: response.response !== undefined ? response.response.data : "No Response"
            });
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          Notification.warning({
            title: "Error",
            message: error
          });
          reject(error);
        });
    });
  },
  recalculateProject(project) {
    let prj = {};
    for (const el in project) {
      prj = project[el];
    }
    return new Promise((resolve, reject) => {
      api
        .post("project/calculate", prj)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            Notification.warning({
              title: "Error",
              message: response.response !== undefined ? response.response.data : "No Response"
            });
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          Notification.warning({
            title: "Error",
            message: error
          });
          reject(error);
        });
    });
  },
  saveCalculatedProject(project) {
    let prj = {};
    for (const el in project) {
      prj = project[el];
    }
    return new Promise((resolve, reject) => {
      api
        .post("project/savecalculatedproject", prj)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            Notification.warning({
              title: "Error",
              message: response.response !== undefined ? response.response.data : "No Response"
            });
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          Notification.warning({
            title: "Error",
            message: error
          });
          reject(error);
        });
    });
  },
  projectChart(chartOptions) {
    return new Promise((resolve, reject) => {
      api
        .post("project/chart", chartOptions)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            Notification.warning({
              title: "Error",
              message: response.response !== undefined ? response.response.data : "No Response"
            });
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          Notification.warning({
            title: "Error",
            message: error
          });
          reject(error);
        });
    });
  },
  availableCharts(project) {
    return new Promise((resolve, reject) => {
      api
        .post("project/availableCharts", project)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            Notification.warning({
              title: "Error",
              message: response.response !== undefined ? response.response.data : "No Response"
            });
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          Notification.warning({
            title: "Error",
            message: error
          });
          reject(error);
        });
    });
  },
  printProject(project) {
    let prj = {};
    for (const el in project) {
      prj = project[el];
    }
    return new Promise((resolve, reject) => {
      report
        .get("ReportView/ReportViewerView", prj)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            Notification.warning({
              title: "Error",
              message: response.response !== undefined ? response.response.data : "No Response"
            });
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          Notification.warning({
            title: "Error",
            message: error
          });
          reject(error);
        });
    });
  },
  getProjectIdNewByExistingProject(modality, projectId) {
    return new Promise((resolve, reject) => {
      api
        .get(`project/getNewProjectIdAndSave/${modality}/${projectId}`)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            Notification.warning({
              title: "Error",
              message: response.response !== undefined ? response.response.data : "No Response"
            });
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          Notification.warning({
            title: "Error",
            message: error
          });
          reject(error);
        });
    });
  },
  getProject(modality, projectId) {
    return new Promise((resolve, reject) => {
      api
        .get(`project/open/${modality}/${projectId}`)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            Notification.warning({
              title: "Error",
              message: response.response !== undefined ? response.response.data : "No Response"
            });
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          Notification.warning({
            title: "Error",
            message: error
          });
          reject(error);
        });
    });
  },
  listProjects() {
    return new Promise((resolve, reject) => {
      api
        .get("project/list/8")
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            Notification.warning({
              title: "Error",
              message: response.response !== undefined ? response.response.data : "No Response"
            });
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          Notification.warning({
            title: "Error",
            message: error
          });
          reject(error);
        });
    });
  },
  listProjectsById(projectsId) {
    return new Promise((resolve, reject) => {
      api
        .post("project/listById", projectsId)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            Notification.warning({
              title: "Error",
              message: response.response !== undefined ? response.response.data : "No Response"
            });
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          Notification.warning({
            title: "Error",
            message: error
          });
          reject(error);
        });
    });
  }
};
